import { FC } from 'react';
import Receipts from 'containers/receipts/receipts';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const ReceiptsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Receipts" />;
  }
  return <Receipts />;
};

export default ReceiptsPage;
